<template>
	<div>
		<sui-modal v-model="open" size="fullscreen">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">Asignar exámen</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="close"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-form @submit.prevent>
						<BaseSelectExamen
							v-model="value.claveExamen"
							titulo="Exámen"
							placeholder="Exámen"
							:error="erroresValidacion && !validationExamen"
						>
						</BaseSelectExamen>
						<sui-form-fields fields="two">
							<div class="field">
								<label class="boldfont">Fecha inicial</label>
								<flat-pickr
									v-model="fechaInicio"
									:config="configDate"
									placeholder="Seleccione la fecha inicial"
									name="date"
								/>
								<div style="margin-top: 5px;">
									<span
										v-show="erroresValidacion && !validationFechaInicio"
										:class="$style.danger"
									>
										<sui-icon name="exclamation circle" />Dato obligatorio
									</span>
								</div>
							</div>
							<div class="field">
								<label class="boldfont">Hora inicial(24hr)</label>
								<flat-pickr
									v-model="horaInicio"
									:config="configTime"
									placeholder="Seleccione la hora inicial"
									name="time"
								/>
								<div style="margin-top: 5px;">
									<span
										v-show="erroresValidacion && !validationHoraInicio"
										:class="$style.danger"
									>
										<sui-icon name="exclamation circle" />Dato obligatorio
									</span>
								</div>
							</div>
						</sui-form-fields>
						<base-button
							class="boldFont submit"
							style-button="primary"
							style-class="right floated"
							:loading="loading"
							@click="aceptar"
						>
							Guardar
						</base-button>
					</sui-form>
				</sui-modal-description>
			</sui-modal-content>
		</sui-modal>
	</div>
</template>
<script>
import {
	formatDateTimeInput,
	dateTimeInputTextToServer
} from '@utils/format-date';

export default {
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		value: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			open: false,
			configDate: {
				dateFormat: 'Y-m-d'
			},
			configTime: {
				enableTime: true,
				noCalendar: true,
				dateFormat: 'H:i',
				time_24hr: true
			},
			erroresValidacion: false
		};
	},
	computed: {
		validationExamen() {
			return (
				this.value &&
				this.value.claveExamen &&
				this.value.claveExamen.trim() !== ''
			);
		},
		validationFechaInicio() {
			return this.fechaInicio && this.fechaInicio.trim() !== '';
		},
		validationHoraInicio() {
			return this.horaInicio && this.horaInicio.trim() !== '';
		},
		horaInicio: {
			get() {
				return this.value && this.value.fechaYHoraInicio
					? formatDateTimeInput(this.value.fechaYHoraInicio).format('HH:mm')
					: null;
			},
			set(val) {
				this.$emit('input', {
					...this.value,
					fechaYHoraInicio: dateTimeInputTextToServer(this.fechaInicio, val)
				});
			}
		},
		fechaInicio: {
			get() {
				return this.value && this.value.fechaYHoraInicio
					? formatDateTimeInput(this.value.fechaYHoraInicio).format(
							'YYYY-MM-DD'
					  )
					: null;
			},
			set(val) {
				this.$emit('input', {
					...this.value,
					fechaYHoraInicio: dateTimeInputTextToServer(val, this.horaInicio)
				});
			}
		}
	},
	watch: {
		open(val) {
			this.erroresValidacion = false;
		}
	},
	mounted() {},
	methods: {
		toggle($event) {
			event.preventDefault();
			this.open = !this.open;
		},
		close() {
			this.open = false;
		},
		aceptar() {
			if (
				this.validationExamen &&
				this.validationFechaInicio &&
				this.validationHoraInicio
			) {
				this.erroresValidacion = false;
				this.$emit('guardar', this.value);
			} else {
				this.erroresValidacion = true;
			}
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.danger {
	color: $background-danger;
}
</style>
